import React from 'react';
import ReactDOM from 'react-dom';
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'

require('typeface-roboto')

import './reset.css';
import 'antd/dist/antd.css';

import App from './App';
import { getDefaults } from './App/actions'
import rootReducer from './App/reducers'
import './index.css';

const loggerMiddleware = createLogger()

const store = createStore(
  rootReducer,
  applyMiddleware(
    thunkMiddleware,
    loggerMiddleware
  )
)
store.dispatch(getDefaults())

ReactDOM.render(
  (
    <Provider store={store}>
      <App />
    </Provider>
  ),
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.jsx